class RefMapper {
  constructor() {
    this.refMap = {};
  }

  // TODO and what happens when you don't have a parent name ? :////
  setOuterElementRef(name, ref) {
    this.refMap[name] = {
      ref,
    };
  }

  // TODO and what happens when you don't have a prent name ? :////
  setChildRef(parentName, childId, ref) {
    this.refMap[parentName] = {
      ...this.refMap[parentName],
      children: {
        ...this.refMap[parentName].children,
        [childId]: {
          ref,
          parent: parentName,
        },
      },
    };
  }

  setSubContentRef(grandParentName, parentName, ref) {
    this.refMap = {
      ...this.refMap,
      [grandParentName]: {
        ...(this.refMap?.[grandParentName] ? this.refMap[grandParentName] : {}),
        children: {
          [parentName]: {
            ...(this.refMap?.[grandParentName]?.children?.[parentName]
              ? this.refMap[grandParentName].children[parentName]
              : {}),
            children: {
              ...(this.refMap?.[grandParentName]?.children?.[parentName]
                ?.children
                ? this.refMap[grandParentName].children[parentName].children
                : {}),
              ref,
            },
          },
        },
      },
    };
  }

  // TODO with the grandparent scheme you now have to reconsider returning a ref
  // even when requested for 'SubSubContent
  getRef(parentName, childName) {
    if (childName) {
      return this.refMap?.[parentName]?.children?.[childName]?.ref ?? null;
    }
    return this.refMap?.[parentName]?.ref ?? null;
  }
}

const instance = new RefMapper();

window.refMapper = instance;

export default instance;
